import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { GetAutomationListRequestDto } from "../../dtos/get-automation-list-request-dto";
import type { GetAutomationListResponseDto } from "../../dtos/get-automation-list-response-dto";
import { AutomationQueryKeys } from "../../generators/automation-query-keys";
import { AutomationService } from "../../services/automation-service";

type UseGetAutomationListQueryParams = {
  queryParams: GetAutomationListRequestDto;
  options?: Omit<UseQueryOptions<GetAutomationListResponseDto>, "queryKey">;
};

export const useGetAutomationListQuery = ({
  queryParams,
  options
}: UseGetAutomationListQueryParams) => {
  return useQuery({
    queryKey: AutomationQueryKeys.getAutomationList({ ...queryParams })
      .queryKey,
    queryFn: async () =>
      await AutomationService.getAutomationList({ payload: queryParams }),
    ...options
  });
};
